
<div class="vehicle-change">
            <h6 class="f-14">{{ 'how_was_vehicle_charged' | translate }}</h6>
            <div class="vehicle-change-radio">
              <div (click)="onDisabledChargingTypeClick(1)">
                <div class="radio-button border-0 p-0 m-0" [class.disabled]="!availableChargingTypes.includes(1)">
                  <input type="radio" name="chargingType" [value]="1" class="top-2px" [checked]="formControl.value === 1"
                     (change)="selectChargingType(1)">
                  <label >
                      <p class="m-0 f-14">{{ 'home_charging_label' | translate }}</p>
                  <p class="f-14">{{ 'rate_label' | translate }} {{ getRateForType(1) | number:mileageRateFormat }} / {{ mileageUOM }}</p>
                  </label>
                </div>
              </div>
              <div (click)="onDisabledChargingTypeClick(2)">
                <div class="radio-button border-0 p-0 m-0" [class.disabled]="!availableChargingTypes.includes(2)">
                  <input type="radio" name="chargingType" [value]="2" class="top-2px" [checked]="formControl.value === 2"
                     (change)="selectChargingType(2)">
                  <label>
                      <p class="m-0 f-14">{{ 'third_party_charging_label' | translate }}</p>
                  <p class="f-14">{{ 'rate_label' | translate }} {{ getRateForType(2) | number:mileageRateFormat }} / {{ mileageUOM }}</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
